module.exports = __webpack_public_path__ + "img/eye-open.6abb9a90.svg";